var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticClass: "d-flex flex-column",
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    height: _vm.height,
    loading: _vm.loading
  }, false), [_c('chat-count'), _c('v-divider'), _c('chat-messages'), _c('v-divider'), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('chat-input')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }